var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ invisible: !_vm.showTable }},[_vm._m(0),_c('div',{staticClass:"description"},[_vm._v("\n    The following submissions require your attention and resolution.\n  ")]),_c('BBDataTable',{staticClass:"needsReview",attrs:{"columns":_vm.columns,"support-add-new":false,"path-url-api":"orders","load-items-fn":_vm.onItemsLoaded,"default-api-params":{
      _fields: 'statuses,createdAt,note,currentStatus',
      _sort: 'createdAt',
      _order: 'desc',
      _fieldsNoPopulate: 'design.name,design._id',
      _filter: [
        {
          field: 'isDeleted',
          op: '=',
          val: 'false'
        },
        {
          field: 'user',
          op: '=',
          val: _vm.userId
        },
        {
          field: 'currentStatus',
          op: '=',
          val: this.orderStatusSubmissionReturned
        }
      ]
    }},scopedSlots:_vm._u([{key:"customCell",fn:function(ref){
    var props = ref.props;
return [(props.column.field == 'attachments')?_c('div',{staticClass:"fileWidth"},_vm._l((props.row.statusAttachmentsNote),function(file){return _c('span',{key:file._id},[_c('font-awesome-icon',{staticClass:"mr-2 fileIcon",attrs:{"id":file._id,"icon":_vm.icons.file},on:{"click":function($event){return _vm.onOpeningUploadedAttachment(file.link)}}}),_c('b-tooltip',{attrs:{"target":file._id,"triggers":"hover","placement":"right"}},[_vm._v("\n            "+_vm._s(file.filename)+"\n          ")])],1)}),0):_vm._e()]}},{key:"customButtons",fn:function(slotProps){return [(slotProps.props.row)?_c('router-link',{staticClass:"btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1",attrs:{"to":{
          name: 'orderReview',
          params: {
            id: slotProps.props.row.design._id,
            orderId: slotProps.props.row._id
          }
        }}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icons.eyeIcon}}),_c('span',{staticClass:"bb-label"},[_vm._v("REVIEW")])],1):_vm._e()]}}])})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("Needs Review")])])}]

export { render, staticRenderFns }